/** Gebäude je Zustand – einmal gebaut, dann wiederverwendet (Szene + Kollision). */
import type { HouseKey } from "@hausplaner/model";
import { buildHouse, type HouseModel } from "../engine/house";
import { VARIANTS } from "../engine/variants";

const cache = new Map<HouseKey, HouseModel>();
export function getHouse(key: HouseKey): HouseModel {
  let h = cache.get(key);
  if (!h) { h = buildHouse(VARIANTS[key].walls); cache.set(key, h); }
  return h;
}
